import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  Upload,
  FileSpreadsheet,
  Save,
  CheckCircle,
} from 'lucide-react';
import * as XLSX from 'xlsx';
import { uploadStats } from '../services/calculator';
import './Calculator.css';

const ExcelUploader = () => {
  const [statsData, setStatsData] = useState();
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (event) => {
      const xlData = new Uint8Array(event.target.result);
      const workbook = XLSX.read(xlData, { type: 'array' });

      // Assuming the data is in the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert the sheet data to JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      console.log(jsonData);
      if (jsonData) {
        setStatsData(jsonData);
      } else {
        alert('Improper file or corrupted data.');
        setFileName('');
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleSave = async () => {
    if (!statsData) {
      alert('Please upload a file first.');
      return;
    }
    setLoading(true);
    try {
      const response = await uploadStats(statsData);
      if (response) {
        setLoading(false);
        alert('All data uploaded successfully!');
        setStatsData(undefined);
        setFileName('');
      }
    } catch {
      setLoading(false);
      alert('Something went wrong!');
    }
  };

  return (
    <div className="calculator-page">
      {/* Main Content */}
      {!loading && (
        <div className="calculator-wrapper">
          {/* Header with Back Button */}
          <div className="calculator-header">
            <button
              onClick={() => navigate(-1)}
              className="calculator-back-btn"
            >
              <ArrowLeft size={18} />
              Back
            </button>
          </div>

          {/* Upload Card */}
          <div className="calculator-card">
            <div className="calculator-card-header">
              <div className="calculator-card-icon">
                <FileSpreadsheet size={28} />
              </div>
              <div>
                <h2>Upload Excel File</h2>
                <p>Upload your Excel spreadsheet to import tool data</p>
              </div>
            </div>

            {/* File Upload Zone */}
            <div className={`file-upload-zone ${statsData ? 'has-file' : ''}`}>
              <input
                type="file"
                id="excel-upload"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
              <label htmlFor="excel-upload">
                <div className="upload-icon">
                  {statsData ? <CheckCircle size={24} /> : <Upload size={24} />}
                </div>
                <span className="file-upload-text">
                  {statsData
                    ? 'File uploaded successfully!'
                    : 'Click to upload or drag and drop'}
                </span>
                <span className="file-upload-hint">
                  Supports .xlsx and .xls files
                </span>
                {fileName && (
                  <span className="file-name">
                    <FileSpreadsheet size={16} />
                    {fileName}
                  </span>
                )}
              </label>
            </div>

            {/* Save Button */}
            <button
              className="calculator-save-btn"
              onClick={handleSave}
              disabled={!statsData}
            >
              <Save size={20} />
              Save Data
            </button>
          </div>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="calculator-wrapper">
          <div className="calculator-card">
            <div className="loading-container">
              <img src="/loading.gif" alt="Loading" />
              <span className="loading-text">
                Uploading data, please wait...
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExcelUploader;
